import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './Stat.scss'

export const STAT_TYPES = {
    battles: 'battles',
    level: 'level',
    players: 'players',
    victories: 'victories',
}
const getValue = (type, number) => {
    if (!number) return <span>{'\u2014'}</span>

    return type === STAT_TYPES.victories ? `${number}%` : number
}

const Stat = ({ title, number, type, className }) => (
    <div className={cx(styles.base, className)}>
        <div className={cx(styles.icon, styles[`icon__${type}`])} />
        <span className={styles.value}>{getValue(type, number)}</span>
        <span className={styles.title}>{title}</span>
    </div>
)

Stat.propTypes = {
    title: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    number: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    className: PropTypes.string,
}

export default Stat



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Card/components/Stat/Stat.jsx